import { Emitter } from "@ciaopeople/cp-shatsu/Queues";
import { debug } from "../../LoginDbg.js";
import { GoogleCredentialResponse, GoogleOneTapDismissReason, GoogleOneTapMomentType, GoogleOneTapPromptNotification, OneTapDelegate } from "../OneTapDelegate.js";
import { GSILoader } from "../commons/GSILoader.js";




export class OneTapDelegateLocalImpl implements OneTapDelegate {
  
    private promptNotificationEmitter: Emitter<GoogleOneTapPromptNotification>;
  


    
    constructor(
        private readonly loader: GSILoader
    ) {
        this.promptNotificationEmitter = new Emitter();
    }   

    oneTapDelegateLogin(): Promise<GoogleCredentialResponse> {
        const prom = this.promptNotificationEmitter.next().then(notification => {
            debug.write("onetap entring ending promise with notification",notification);
            if(notification.moment == GoogleOneTapMomentType.dismissed &&
                notification.dismissReason == GoogleOneTapDismissReason.credential_returned) {
                debug.write("onetap waiting for next credential response");
                return this.loader.getNextCredentialResponse().then((response) => {
                    debug.write("Got Response from onetap: ", response);                   
                    return response;
                });
            }
            else return Promise.reject(notification);
        });
        this.loader.gsiInit().then((gaccounts) => {
            debug.write("Prompting one tap");
            gaccounts.id.prompt((notification) => {
                let moment: GoogleOneTapMomentType = null; 
                let dismissReason: GoogleOneTapDismissReason = null;
                if(notification.isDismissedMoment()) {
                    moment = GoogleOneTapMomentType.dismissed;
                    dismissReason = notification.getDismissedReason();
                    const toEmit = {
                        moment: moment, 
                        dismissReason: dismissReason
                    };
                    this.promptNotificationEmitter.emit(toEmit);
                    debug.write("got back from onetap", notification, toEmit);
                }
                else {
                    debug.write("onetap not emitting on",notification);
                }
                
            });
        });
        return prom;
    }

    oneTapDelegateRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        return this.loader.gsiInit().then((gaccounts) => {
            return new Promise<boolean>((resolve) => {
                try {
                    debug.write("GOT - Disabling AutoSelect");
                    gaccounts.id.disableAutoSelect();
                    if(hint && isDeleteRequest) {
                        debug.write("GOT - Also revoking");
                        gaccounts.id.revoke(hint, (done) => {
                            debug.write("GOT - Outcome of id revoke", done);
                            resolve(true);
                        });
                    }
                    else resolve(true);
                    
                }
                catch(e) {
                    debug.write("GOT- There was an error disabling autoselect / revoke", e);
                    resolve(false);
                }
            }).catch(_ => {
                return Promise.resolve(false);
            });
            
        });
    }

}